import { render, staticRenderFns } from "./ListUmpp.vue?vue&type=template&id=6a0b0e94&"
import script from "./ListUmpp.vue?vue&type=script&lang=js&"
export * from "./ListUmpp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports